import React from 'react'
import { useState, useEffect } from 'react';


import firebase from "gatsby-plugin-firebase"
import useUser from "../hooks/useUser"


function getMoodColor(sentimentScore, sentimentMagnitude) {
    let new_sentiment_color = (-sentimentScore + 1) * 90;
    let new_magnitude_color = Math.min(sentimentMagnitude * 90, 90);
    return "hsl(" + new_sentiment_color + ", " + new_magnitude_color + "%, 70%)";
}

export default () => {

    const user = useUser()
    const [overallEntityData, setEntityData] = useState([])

    const epic_style = {
        backgroundColor: "#F7E3AF",
        borderRadius: 2,
        padding: 1
    };

    useEffect(() => {
        if (user) {
            const db = firebase.firestore()
            console.log(user.uid)

            var combined_text = "";

            db.collection('users').doc(user.uid).collection('journals').get().then(querySnapshot => {
            querySnapshot.forEach(doc => {
                const journal = doc.data();

                combined_text = combined_text + '\n' + journal.text;
                console.log(journal.text)

                console.log("GETTING DATA IN ENTITY MOOD")

            }) 
            

            console.log("COMBINED: ", combined_text);

            fetch("https://language.googleapis.com/v1/documents:analyzeEntitySentiment?key=AIzaSyAdNS7eUqUGXq5ogNnTsereth_e1SFR3rw", {
                body: JSON.stringify({
                    'document': {
                        'type': 'PLAIN_TEXT',
                        'content': combined_text,
                    },
                    'encodingType': 'UTF8'
                }),
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                },
                method: "POST"
            })
            .then((response) => response.json())
            .then((data) => {
                setEntityData(data.entities);
                console.log("ENTITY DATA", data.entities);
            })  
        })
    }}, [user])

    return(
        <>
        <p>Recently, these things have been on your mind:</p>
        {
            overallEntityData.map(
                (entity) => {
                    if (entity.salience > 0.1) {
                        return <div style = {{backgroundColor: getMoodColor(entity.sentiment.score, entity.sentiment.magnitude), borderRadius: 3}}>
                            <p style={{ color: "#ffffff", padding: 5 }}>{ '"' + entity.name + '" was mentioned ' + entity.mentions.length + ' times.'}</p>
                            </div>
                    }
                    else return;
                }
            )
        }
        </>
    )
}